// Auth utility functions for browser environment
import { encryptObject, decryptObject } from './crypto'
import { STORAGE_KEYS } from './constants.js'

const STORAGE_KEY = STORAGE_KEYS.USER_SESSION

export const authUtil = {
  /**
   * Get token from encrypted storage
   */
  getToken() {
    try {
      const encryptedSession = localStorage.getItem(STORAGE_KEY)
      if (!encryptedSession) return null

      if (encryptedSession.startsWith('CRYPT_')) {
        const decrypted = decryptObject(encryptedSession)
        return decrypted?.token || null
      }
      return null
    } catch (error) {
      console.error('Failed to get token:', error)
      return null
    }
  },

  /**
   * Get authorization header
   */
  getAuthHeader() {
    try {
      const encryptedSession = localStorage.getItem(STORAGE_KEY)
      if (!encryptedSession) return {}

      if (encryptedSession.startsWith('CRYPT_')) {
        const decrypted = decryptObject(encryptedSession)
        const token = decrypted?.token
        return token ? { Authorization: `Bearer ${token}` } : {}
      }
      return {}
    } catch (error) {
      console.error('Failed to get auth header:', error)
      return {}
    }
  },

  /**
   * Check if token is expired
   */
  isTokenExpired() {
    // Implement token expiration check if needed
    return false
  }
}

/**
 * Get language from storage
 */
export function getLanguageFromStorage() {
  try {
    const encryptedLocale = localStorage.getItem(STORAGE_KEYS.ENCRYPTED_LOCALE)
    if (encryptedLocale && encryptedLocale.startsWith('CRYPT_')) {
      const decrypted = decryptObject(encryptedLocale)
      if (decrypted && decrypted.locale) {
        return decrypted.locale
      }
    }

    const locale = localStorage.getItem(STORAGE_KEYS.LOCALE)
    if (locale) {
      return locale
    }

    return 'zh'
  } catch (error) {
    return 'zh'
  }
}

/**
 * Save language to storage with encryption
 */
export function saveLanguageToStorage(lang) {
  try {
    const encrypted = encryptObject({ locale: lang, timestamp: Date.now() })
    localStorage.setItem(STORAGE_KEYS.ENCRYPTED_LOCALE, encrypted)
    localStorage.setItem(STORAGE_KEYS.LOCALE, lang)
  } catch (error) {
    // Silent fail
  }
}